import React, { useContext } from 'react';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import InfoIcon from '@material-ui/icons/Info';
import styled from 'styled-components';
import { AppContext } from '../../contexts/AppContext';

const useStyles = makeStyles((theme) => ({
    popover: {
        pointerEvents: 'none',
    },
    paper: {
        padding: theme.spacing(1),
        maxWidth: '200px',
    },
}));

const Container = styled.div`
    display: inline-block;
`



export default function Tooltip({ text }) {

    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const {sendEvent} = useContext(AppContext)

    const handlePopoverOpen = (event) => {
        sendEvent("Powerpacks", "Hover", "Hover PowerPack Tooltip")
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
        <Container>
            <InfoIcon
                aria-owns={open ? 'mouse-over-popover' : undefined}
                aria-haspopup="true"
                onMouseEnter={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}
            ></InfoIcon>
            <Popover
                id="mouse-over-popover"
                className={classes.popover}
                classes={{
                    paper: classes.paper,
                }}
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                onClose={handlePopoverClose}
                disableRestoreFocus
            >
                <Typography>{text}</Typography>
            </Popover>
        </Container>
    );
}